import { render, staticRenderFns } from "./TypingUsersList.vue?vue&type=template&id=06966da4&"
import script from "./TypingUsersList.vue?vue&type=script&lang=js&"
export * from "./TypingUsersList.vue?vue&type=script&lang=js&"
import style0 from "./TypingUsersList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports